import { render, staticRenderFns } from "./data-category-button.vue?vue&type=template&id=2a4220a6&scoped=true&"
import script from "./data-category-button.vue?vue&type=script&lang=js&"
export * from "./data-category-button.vue?vue&type=script&lang=js&"
import style0 from "./data-category-button.vue?vue&type=style&index=0&id=2a4220a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4220a6",
  null
  
)

export default component.exports